import React from 'react';
import './LeadgenPreloader.css';

export default function LeadgenPreloader() {
  return (
    <div className="leadgen-preloader">
      <div className="creative-spinner">
        <div className="dot dot1"></div>
        <div className="dot dot2"></div>
        <div className="dot dot3"></div>
        <div className="dot dot4"></div>
      </div>
      <div className="preloader-text">Finding the best leads for you...</div>
    </div>
  );
}
